<template>
  <div>
    <!-- testimonial Section start-->
    <section id="testimoni" class="testimonial page-margin">
      <div class="testimonial-decor">
        <div class="testi-circle1"><img :src='"../assets/images/testimoni-page.png"' alt=""></div>
        <div class="testi-circle2"><img :src='"../assets/images/testimoni-page2.png"' alt=""></div>
      </div>
      <div class="container">
        <h2 class="title text-center mt-3"><span>Testimoni</span></h2>
        <div class="row">
          <div class="col-lg-10 offset-lg-1">
              <carousel v-if="loaded"
                        :className='"testimonial-carousel "'
                        :loop=true
                        :margin=30
                        :items=1
                        :center=true
                        :nav=true
                        :dots=false
                        :dotsEach=false
                        :autoplay=true
                        :responsive="{0:{items:1,dots:true,nav:false},768:{items:1,dots:true,nav:false},992:{nav:true}}"
              >
               <div 
                class="testimonial-item"
                v-for="(item, index) in testi"
                :key="item.index"
                >
                <div class="testimonial-block">
                  <div class="testimonial-avtar">
                    <img :src='"../assets/images/avtar/22.jpg"' alt="">
                  </div>
                  <div class="testimonial-text">
                    <p>{{ item.ulasan }}</p>
                    <h3 v-if="item.perusahaan_organisasi != null" >{{ item.name }} - {{ item.perusahaan_organisasi }}</h3>
                    <h3 v-else >{{ item.name }}</h3>
                    <h3>{{ item.name }}</h3>
                    <h6>{{ item.jabatan }}</h6>
                  </div>
                </div>
              </div>

              
            </carousel>
          </div>
        </div>
      </div>
    </section>
    <!-- testimonial Section End -->
  </div>
</template>
<script>
import Testimoni from '../api/testimoniumum';

export default {
  name: 'Testimonial',
  data() {
    return {
      loaded:false,
      testi: [],
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      Testimoni.index()
      .then(res => {
        this.testi = res.data.data
        this.loaded = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/testimonial.vue